<div class="timeline-track" [ngClass]="customClass">
  <ng-container *ngIf="items && items.length > 0">
    <app-audit-trail-node
      *ngFor="let item of items; let isLast = last"
      [title]="item.title"
      [time]="item.time || ''"
      [description]="item.description || ''"
      [dotColor]="item.dotColor || 'slate'"
      [titleColor]="item.titleColor || 'default'"
      [isNote]="!!item.isNote"
      [isLast]="isLast">
    </app-audit-trail-node>
  </ng-container>
  <ng-content></ng-content>
</div>
